module.exports = __webpack_public_path__ + "media/images/banner/covid/en-6f62fa312fdac925a67aefba3a6e13bc.jpg";